import SolutionForm from "./SolutionForm.container";

export default SolutionForm;
